import { useState } from "react";

// Created this hook to simplify ExerciseEditor.js file

// Basically handles the add set state with the buttons to submit or discard the new set
// It uses a state to indicate if the user is adding a new set, and the index of the row
// to know if we should show/hide the row actions buttons

export const useQuickEditAddSet = ({ onSubmitCallback }) => {
  const [addingSet, setAddingSet] = useState({
    state: false,
    index: undefined,
  });

  const onAddSet = (setIdx) => {
    setAddingSet({ state: true, index: setIdx });
  };

  const onSubmitSet = () => {
    onSubmitCallback();
    setAddingSet({ state: false, index: undefined });
  };

  const onDiscardSet = () => {
    setAddingSet({ state: false, index: undefined });
  };

  return {
    addingSet,
    setAddingSet,
    onAddSet,
    onSubmitSet,
    onDiscardSet,
  };
};
